import React from "react";
import DynamicIcon from "./dynamic-icon";
import ModalPortal from "../layout/modal-portal";

const Modal = ({ children, additionalclasses, isOpen, toggleModal, heading, ignoreX, childrenClasses}) => {
  return isOpen ? (
    <ModalPortal>
      <div onClick={toggleModal} className="fixed grid z-[9999999] items-center justify-center content-center left-0 top-0 h-screen w-screen backdrop-blur-sm bg-[#00000059] ignore-click">
        <div onClick={(e) => e.stopPropagation()} className={`grid content-start bg-white-200 dark:bg-grey-600 rounded-[8px] pb-[20px] ${additionalclasses}`}>
         {heading &&  <div className={`flex ${heading ? 'justify-between' : 'justify-end'} py-[11px] px-[18px]`}>
            <span className="text-[14px] custom-text-grey-600 poppins-medium">{heading}</span>
            {!ignoreX && <DynamicIcon onClick={toggleModal} name='x' size={18} color='custom-text-grey-800 cursor-pointer' />}
          </div>}
          {heading && <div className="border-b-[1px] custom-border-white-50 mb-[8px]"></div>}
          <div className={`px-[16px] ${childrenClasses}`}>
            {children}
          </div>
        </div>
      </div>
    </ModalPortal>
  ) : null;
};

export default Modal;